import groq from 'groq';

/* WARN: If you change this query, make sure to update MAX_POSSIBLE_SCORES */
export const searchStudies = () => groq`
  *[
    _type == "timeline_studies" &&
    !(_id in path("drafts.**"))
  ] |
    score(
      description match $searchTerm,
      studyGroups[].title match $searchTerm,
      studyGroups[].description match $searchTerm,
      studyGroups[].studies[].title match $searchTerm,
      studyGroups[].studies[].description match $searchTerm
    ) {
      _type,
      _score
    }[ _score > 0 ]
`;
